module.exports = __webpack_public_path__ + "static/media/about_us_icon.d8151df6.png";